import SelectComponent from 'components/Select';
import useSeasonIndex from 'hooks/useSeasonIndex';
import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface SeasonIndexFilterProps {
  country: string;
  seasonIndex: string | undefined;
  setSeasonIndex:
    | React.Dispatch<React.SetStateAction<string | null>>
    | ((seasonIndex: string | null) => void);
}

const SeasonIndexFilter = ({
  seasonIndex,
  setSeasonIndex,
  country,
}: SeasonIndexFilterProps) => {
  const { t } = useTranslation();
  const { seasonIndexFilterOptions, currentSeason } = useSeasonIndex(country);

  /*
    When navigating between pages, the seasonIndex options are cached,
    but the seasonIndex state needs to be initialized with the current season.

    Using useEffect here would delay the state update until after the dom paint,
    causing a brief layout shift (initial empty state -> loaded state),
    which defeats the benefit of caching.

    as useLayoutEffect runs before the paint, it allows us to synchronously set
    seasonIndex and avoid flickering or unnecessary re-renders.
    
    - Varadarajan
  */
  useLayoutEffect(() => {
    if (!currentSeason) return;
    setSeasonIndex(currentSeason?.id);
  }, [currentSeason]);

  return (
    <SelectComponent
      label={t('common.filters.season')}
      options={seasonIndexFilterOptions}
      value={seasonIndex}
      placeholder={t('common.filters.selectSeason')}
      onChange={setSeasonIndex}
    />
  );
};

export default SeasonIndexFilter;
